// https://en.wikipedia.org/wiki/ISO_3166-2
// Sync with onestaff-api: Enum/CompanyRegistrationCountry

import { CountriesAllCodes } from './CountriesAllCodes';

// Sync with onestaff-infra: amazon/lambda-address-service/lambda_address_service.js
export enum Countries {
    France = CountriesAllCodes.France,
    Belgium = CountriesAllCodes.Belgium,
    Switzerland = CountriesAllCodes.Switzerland,
    Cyprus = CountriesAllCodes.Cyprus,
    Luxembourg = CountriesAllCodes.Luxembourg,
    Ireland = CountriesAllCodes.Ireland,
    Netherlands = CountriesAllCodes.Netherlands,
    Romania = CountriesAllCodes.Romania,
    UnitedKingdom = CountriesAllCodes.UnitedKingdom,
    UnitedStates = CountriesAllCodes.UnitedStates,
    Italy = CountriesAllCodes.Italy,
    Germany = CountriesAllCodes.Germany,
}
